import React from "react";
import { Operations } from './NavigatorData';

export interface OperationContextInterface {
  operationType: Operations;
  handleConfigOperationChange: (operation: Operations) => void;
}

const defaultOperationContext: OperationContextInterface = {
  operationType: Operations.compare,
  handleConfigOperationChange: (operation: Operations) => { }
}


export const OperationContext = React.createContext(defaultOperationContext);